import React from 'react';
import { Form } from 'src/components/RcForm';

const ChangesMonitor = (props) => {
  const { setHasModified, pcForm, tabletForm, mobileForm, loaded } = props;
  const pD = Form.useWatch([], pcForm);
  const tD = Form.useWatch([], tabletForm);
  const mD = Form.useWatch([], mobileForm);

  React.useEffect(() => {
    if (setHasModified && loaded) {
      setHasModified(true);
    }
  }, [pD, tD, mD]);
  return <React.Fragment />;
};
export default ChangesMonitor;
